import UserData from './userData'
import {globalToast} from './globalToast'
import {
  wechatSharePkgPage,
  wechatShareAlbum
} from './wechatShare'
import { wechatPay } from './wechatPay'


export {
  UserData,
  wechatSharePkgPage,
  globalToast,
  wechatPay,
  wechatShareAlbum
}